import { jsx as _jsx } from "react/jsx-runtime";
import { withStyle } from 'styletron-react';
import { getSpacing } from '../../const/spacing';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { StyledLayoutBase, layoutBasePropsToStyledProps } from './LayoutBase';
import { getAlignItems } from './helpers/getAlignItems';
import { getJustifyContent } from './helpers/getJustifyContent';
const StyledGridContainer = withStyle(StyledLayoutBase, (p) => ({
    display: 'grid',
    gridTemplateColumns: p.$columns,
    gridTemplateRows: p.$rows,
    gap: getSpacing(p.$gap),
    alignItems: getAlignItems('column', p.$horizontalAlign, p.$verticalAlign),
    justifyContent: getJustifyContent('column', p.$horizontalAlign, p.$verticalAlign),
}));
export const GridContainer = ({ children, columns, rows, gap = '0', horizontalAlign = 'none', verticalAlign = 'none', testId, ...layoutBaseProps }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsx(StyledGridContainer, { $columns: columns, $rows: rows, $gap: gap, $horizontalAlign: horizontalAlign, $verticalAlign: verticalAlign, ...layoutBasePropsToStyledProps(layoutBaseProps), ...testIdAttribute, children: children }));
};
